import { useCallback, useEffect, useState } from 'react';
import api from '../utils/axiosConfig';

export default function useResources() {
    const [attempt, setAttempt] = useState(0);
    const [result, setResult] = useState({ status: 'loading', articles: [], sources: [] });
    useEffect(() => {
        const controller = new AbortController();
        setResult({ status: 'loading', articles: [], sources: [] });
        api.get('/api/resources', { signal: controller.signal }).then(({ data }) => {
            if (controller.signal.aborted) return;
            if (!Array.isArray(data.articles) || !Array.isArray(data.sources)) throw new Error('Invalid resources response');
            setResult({ status: 'ready', articles: data.articles, sources: data.sources });
        }).catch(() => {
            if (!controller.signal.aborted) setResult({ status: 'error', articles: [], sources: [] });
        });
        return () => controller.abort();
    }, [attempt]);
    const retry = useCallback(() => setAttempt(value => value + 1), []);
    return { ...result, retry };
}
